import React, { useState, useEffect } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  colors,
  Divider,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { ConsumableUnitOptions } from 'api/consumablesApi';

interface Props {
  label: string;
  onChange: (data: string[]) => void;
  defaultSelected?: string[];
}

const MultiItemTypeAutoCompleteForFilters = ({
  label,
  onChange,
  defaultSelected,
}: Props) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    if (
      defaultSelected &&
      defaultSelected.length > 0 &&
      ConsumableUnitOptions
    ) {
      const selectedData = ConsumableUnitOptions?.filter((item) =>
        defaultSelected.includes(item)
      );
      setSelected(selectedData);
    } else {
      setSelected([]);
    }
  }, [defaultSelected, ConsumableUnitOptions]);

  return (
    <>
      <Autocomplete
        multiple
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={!ConsumableUnitOptions ? [] : [...ConsumableUnitOptions]}
        loading={open && !ConsumableUnitOptions}
        getOptionLabel={(option) => (typeof option === 'string' ? option : '')}
        value={selected}
        renderOption={(option) => (
          <span>
            <Box display="block">
              <Typography variant="body1">{option}</Typography>
            </Box>
          </span>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index: number) => (
            <Chip
              sx={{ marginRight: '0.4rem' }}
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        getOptionSelected={(option, value) => option === value}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {open && !ConsumableUnitOptions && (
                    <CircularProgress color="inherit" size={20} />
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        onChange={(_, data: string[]) => {
          onChange && onChange(data.map((u) => u));
        }}
        PaperComponent={(paperProps) => {
          const { children, ...restPaperProps } = paperProps;
          return (
            <Paper {...restPaperProps}>
              {ConsumableUnitOptions?.length > 0 && (
                <Box onMouseDown={(e) => e.preventDefault()} pl={1.5} py={0.5}>
                  <FormControlLabel
                    onClick={(e) => {
                      e.preventDefault();
                      onChange &&
                        onChange(ConsumableUnitOptions?.map((u) => u));
                      setOpen(false);
                    }}
                    label=""
                    control={
                      <Box m={1}>
                        <Button
                          id="select-all-checkbox"
                          variant="outlined"
                          size="small"
                          sx={{
                            color: colors.grey[600],
                            borderColor: colors.grey[600],
                          }}>
                          Select all
                        </Button>
                      </Box>
                    }
                  />
                </Box>
              )}
              <Divider />
              {children}
            </Paper>
          );
        }}
      />
    </>
  );
};

export default MultiItemTypeAutoCompleteForFilters;
